import { humanizeText } from "./StringFormatters";
import { wholeNumberWithCommas } from "./NumberFormatter";

export const isGrantee = (entity_type_code) => {
  if (!entity_type_code) {
    return false;
  }

  if (!["RRC", "SCH", "CAH", "DSH", "PED", "CAN"].includes(entity_type_code)) {
    return true;
  }

  return false;
};

export const isLimitedGrantee = (entity_type_code) => {
  if (!entity_type_code) {
    return false;
  }

  if (!["RRC", "SCH", "CAH", "DSH", "PED", "CAN", "CH", "CHC"].includes(entity_type_code)) {
    return true;
  }

  return false;
};

export const isLimitedHospitalAndGrantee = (entity_type_code) => {
  if (!entity_type_code) {
    return false;
  }

  if (!["RRC", "SCH", "CAH", "DSH", "CH", "CHC"].includes(entity_type_code)) {
    return true;
  }

  return false;
};

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});

export const displayNDC = (ndc) => ndc.replace(/^(\d{5})(\d{4})(\d{2})$/, "$1-$2-$3");
export const displayBalance = (val) => (val != 0 ? wholeNumberWithCommas(val) : "--");
export const displayBalanceFloat = (val) => (val != 0 ? displayFloat(parseFloat(val)) : "--");
export const displayCurrency = (val) => formatter.format(val);

// follows RoRs standard error output shape.
export const displayResponseErrors = (errorObject) => {
  return Object.entries(errorObject)
    .map(([field, messages]) => {
      return `${humanizeText(field)} ${Array.isArray(messages) ? messages.join(", ") : messages}.`;
    })
    .join(" ");
};

export const pharmacyGroupSort = (a, b) => {
  // 1. unassigned first
  const isFirstPriority = (name) => name === "unassigned";

  if (isFirstPriority(a.name) && !isFirstPriority(b.name)) return -1;
  if (isFirstPriority(b.name) && !isFirstPriority(a.name)) return 1;

  // 2. in_house second
  if (a.name === "in_house" && b.name !== "in_house") return -1;
  if (b.name === "in_house" && a.name !== "in_house") return 1;

  // 3. alphabetical for everything else
  return a.name.localeCompare(b.name);
};

export const formatPharmacyGroupName = (name) => {
  return name === "in_house" ? "CE Pharmacies and Clinics" : humanizeText(name);
};

export const formatMappingRequestStatus = (status) => {
  switch (status) {
    case "approved":
      return "In Review";
    case "withdrawn":
      return "Denied";
  }

  return humanizeText(status);
};

export const calculatePercentage = (num, den) => {
  if (!den || den === 0) return 0; // Blocks both NaN and Infinity
  return Math.round((num / den) * 100);
};

export const displayFloat = (num) =>
  num.toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
